import $ from 'jquery';
import 'summernote/dist/summernote-lite';
import 'summernote/dist/summernote-lite.css';
export default class RichTextEditor {
    static $summerNoteEditor = $('.summernote-editor');
    static $summerNoteSimpleTextEditor = $('.js__summer-note-simple-text');
    static $summerNoteLimitedEditor = $('.js__summer-note-limited');
    static $slideTitleEditor = $('.js__summer-note-title');
    static $slideDescriptionEditor = $('.js__summer-note-description');
    static $slideMobileTitleEditor = $('.js__summer-note-mobile-title');
    static $slideMobileDescriptionEditor = $('.js__summer-note-mobile-description');
    static $summerNoteSubmit = $('form.loadable-dimmer button[type="submit"]');
    static stripWWW(url) {
        return url.indexOf('www.') === 0 ? url.slice(4) : url;
    }
    static addRelAttributeToLinks($wrapper) {
        const $a = $wrapper.find('a');
        $a.each((index, element) => {
            const $element = $(element);
            const targetHostname = this.stripWWW($element[0].hostname);
            const currentHostname = this.stripWWW(location.hostname);
            const isExternalUrl = targetHostname !== currentHostname;
            if (isExternalUrl && !$element.attr('rel')) {
                const isTargetBlank = $element.attr('target') === '_blank';
                $element.prop('rel', `nofollow${isTargetBlank ? ' noreferrer noopener' : ''}`);
            }
        });
    }
    static defaultSummernoteOptions = {
        dialogsInBody: true,
        disableDragAndDrop: true,
        callbacks: {
            onPaste(event) {
                RichTextEditor.pasteWithoutFormatting(event);
            },
            onChange: (contents, $editable) => {
                this.addRelAttributeToLinks($editable);
            },
            onInit: () => {
                const $dialog = $('.note-modal.link-dialog');
                $dialog.each((index, element) => {
                    const $element = $(element);
                    if (!$element.hasClass('js__added_link_popup_inputs')) {
                        const extraOptions = `
            <div class="checkbox">
                <label>
                    <input class="js__system-asset-checkbox" role="checkbox" type="checkbox">
                    Link to system asset (image, video...)
                </label>
            </div>
          `;
                        $element.find('.note-link-url').parent().after(extraOptions);
                        $element.addClass('js__added_link_popup_inputs');
                    }
                });
            },
            onDialogShown: () => {
                const $dialog = $('.note-modal.link-dialog.open');
                const indexOfDialog = $('.note-modal.link-dialog').index($('.note-modal.link-dialog.open'));
                const $linkUrlInput = $dialog.find('.note-link-url');
                const $systemAssetCheckbox = $dialog.find('.js__system-asset-checkbox');
                const $summernoteInstance = $($('.js__summernote-editor').get(indexOfDialog));
                const range = $summernoteInstance.summernote('invoke', 'editor.getLastRange');
                //@ts-ignore
                const $parentAnchor = $(range.sc).closest('a');
                if ($parentAnchor.length) {
                    setTimeout(() => {
                        const link = $parentAnchor.attr('href') || '';
                        const isAssetLink = link.includes('asset(');
                        $systemAssetCheckbox.prop('checked', isAssetLink);
                        if (isAssetLink) {
                            $linkUrlInput.val(this.extractAssetPath($parentAnchor.attr('href') || '') || '');
                        }
                    });
                }
                $linkUrlInput.on('blur', event => {
                    setTimeout(() => {
                        const isAssetLink = $systemAssetCheckbox.is(':checked');
                        if (isAssetLink) {
                            const $input = $(event.currentTarget);
                            const value = String($input.val() || '');
                            if (value) {
                                $input.val(value.replace('http://', ''));
                            }
                        }
                    });
                });
                $dialog
                    .find('.note-link-btn')
                    .off('click')
                    .on('click', () => {
                    const isAssetLink = $systemAssetCheckbox.is(':checked');
                    const trimmedUrl = String($linkUrlInput.val())?.trim();
                    const url = isAssetLink ? trimmedUrl.replace('http://', '') : trimmedUrl;
                    if (url) {
                        setTimeout(() => {
                            let $insertedLink = $('a[href="' + trimmedUrl + '"]');
                            if (!$insertedLink.length) {
                                $insertedLink = $('a[href="http://' + trimmedUrl + '"]');
                            }
                            const link = $insertedLink.attr('href');
                            if (isAssetLink && link && !link.includes('asset(')) {
                                $insertedLink.attr('href', `{{ asset('${url}', 'shop') }}`);
                            }
                            else if (!isAssetLink && link && link.includes('asset(')) {
                                $insertedLink.attr('href', url);
                            }
                            $('.js__summernote-editor').trigger('summernote.change');
                        }, 100);
                    }
                });
            },
        },
    };
    static summerNoteOptions = {
        ...RichTextEditor.defaultSummernoteOptions,
        toolbar: [
            ['style', ['style', 'bold', 'italic', 'underline', 'clear']],
            ['font', ['strikethrough', 'superscript', 'subscript']],
            ['color', ['color']],
            ['para', ['ul', 'ol', 'paragraph']],
            ['table', ['table']],
            ['insert', ['link', 'picture']],
            ['misc', ['codeview', 'undo', 'redo', 'help']],
        ],
        styleTags: [
            'p',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            // @ts-ignore
            { title: 'Paragraph block', tag: 'p', className: 'paragraph-block', value: 'p' },
        ],
        maximumImageFileSize: 1048576,
        codeviewFilter: false,
        codeviewIframeFilter: false,
        dialogsInBody: true,
    };
    static summerNoteSliderOptions = {
        ...RichTextEditor.defaultSummernoteOptions,
        toolbar: [
            ['style', ['bold', 'italic', 'underline', 'clear']],
            ['font', ['strikethrough', 'superscript', 'subscript']],
            ['fontsize', ['fontsize']],
            ['height', ['height']],
            ['color', ['forecolor']],
            ['para', ['paragraph']],
            ['insert', ['picture']],
            ['misc', ['codeview', 'undo', 'redo', 'help']],
        ],
        fontSizes: ['14', '16', '18', '20', '22', '24', '28', '32', '36', '40', '46', '50', '60'],
        lineHeights: ['1', '1.2', '1.5'],
        maximumImageFileSize: 1048576,
        codeviewFilter: false,
        codeviewIframeFilter: false,
    };
    static summerNoteSimpleTextOptions = {
        ...RichTextEditor.defaultSummernoteOptions,
        toolbar: [
            ['style', ['bold', 'italic', 'underline', 'clear']],
            ['insert', ['link']],
            ['misc', ['undo', 'redo', 'help']],
        ],
        keyMap: {
            pc: {
                ESC: 'escape',
                ENTER: 'insertParagraph',
                'CTRL+Z': 'undo',
                'CTRL+Y': 'redo',
                'CTRL+B': 'bold',
                'CTRL+I': 'italic',
                'CTRL+U': 'underline',
                'CTRL+BACKSLASH': 'removeFormat',
                'CTRL+K': 'linkDialog.show',
            },
            mac: {
                ESC: 'escape',
                ENTER: 'insertParagraph',
                'CMD+Z': 'undo',
                'CMD+SHIFT+Z': 'redo',
                'CMD+B': 'bold',
                'CMD+I': 'italic',
                'CMD+U': 'underline',
                'CMD+BACKSLASH': 'removeFormat',
                'CMD+K': 'linkDialog.show',
            },
        },
    };
    static summerNoteLimitedOptions = {
        ...RichTextEditor.defaultSummernoteOptions,
        toolbar: [
            ['style', ['bold', 'italic', 'underline', 'clear']],
            ['font', ['strikethrough', 'superscript', 'subscript']],
            ['color', ['color']],
            ['para', ['ul', 'ol', 'paragraph']],
            ['insert', ['link']],
            ['misc', ['codeview', 'undo', 'redo', 'help']],
        ],
        codeviewFilter: false,
        codeviewIframeFilter: false,
    };
    static init() {
        this.$summerNoteEditor = $('.summernote-editor');
        this.$summerNoteSimpleTextEditor = $('.js__summer-note-simple-text');
        this.$summerNoteLimitedEditor = $('.js__summer-note-limited');
        this.$slideTitleEditor = $('.js__summer-note-title');
        this.$slideDescriptionEditor = $('.js__summer-note-description');
        this.$slideMobileTitleEditor = $('.js__summer-note-mobile-title');
        this.$slideMobileDescriptionEditor = $('.js__summer-note-mobile-description');
        this.$summerNoteSubmit = $('form.loadable-dimmer button[type="submit"]');
        this.$summerNoteSubmit.on('click', function () {
            return $(this).closest('form').addClass('loading');
        });
        this.$summerNoteEditor
            .summernote({
            ...this.summerNoteOptions,
            callbacks: {
                ...this.summerNoteOptions.callbacks,
                onInit: () => {
                    $('.internal').closest('.field').find('.note-editor').addClass('disabled-field');
                },
            },
        })
            .addClass('js__summernote-editor');
        this.$summerNoteSimpleTextEditor.summernote(this.summerNoteSimpleTextOptions).addClass('js__summernote-editor');
        this.$summerNoteLimitedEditor.summernote(this.summerNoteLimitedOptions).addClass('js__summernote-editor');
        this.$slideTitleEditor.summernote(this.summerNoteSliderOptions).addClass('js__summernote-editor');
        this.$slideDescriptionEditor.summernote(this.summerNoteSliderOptions).addClass('js__summernote-editor');
        this.$slideMobileTitleEditor.summernote(this.summerNoteSliderOptions).addClass('js__summernote-editor');
        this.$slideMobileDescriptionEditor.summernote(this.summerNoteSliderOptions).addClass('js__summernote-editor');
    }
    static pasteWithoutFormatting(event) {
        const bufferText = (event.originalEvent.clipboardData || window.clipboardData).getData('Text');
        event.preventDefault();
        setTimeout(() => {
            // Eses `setTimeout` to solve FF problem with not inserting a text
            document.execCommand('insertText', false, bufferText);
        }, 10);
    }
    static extractAssetPath(input) {
        const match = input.match(/\{\{\s*asset\(\s*'([^']+)'/);
        return match ? match[1] : null;
    }
}
